import background from '../img/about_bg.jpg'
import instagram from '../img/brandlogos/instagram.png'
import youtube from '../img/brandlogos/youtube.png'
import spotify from '../img/brandlogos/spotify.png'
import amazon from '../img/brandlogos/amazon_music.png'
import apple from '../img/brandlogos/apple_music.svg'
import youtubeMusic from '../img/brandlogos/youtube_music.png'

var logoHeight = 48

function Sounds() {
  return (
    <div class="about-box" style={{ backgroundImage: `url(${background})`, backgroundRepeat: 'repeat-y', backgroundSize: '100%', backgroundPosition: 'center' }}>
        <div class="about-column-text">
          <h2>Besuch uns auf</h2>
          <a class="social-link" href="https://www.instagram.com/kuestenspacken" alt="Folge uns auf Instagram" target='BLANK'>
            <img src={instagram} height={logoHeight} />
          </a>
          
          <a class="social-link" href="https://www.youtube.com/@leifollenstaedt2971" alt="Abonniere uns auf YouTube" target="BLANK">
            <img src={youtube} height={logoHeight} />
          </a>
          <h2>Oder höre uns auf</h2>
          <a class="social-link" alt="Höre uns auf Spotify" href="https://open.spotify.com/intl-de/artist/6trL4cpMyqZfYzG1qWff2Q?si=Q_DOZTJOR6-lmR0VN4nTMg" target='BLANK'>
            <img src={spotify} height={logoHeight} />
          </a>
          <a class="social-link" alt="Höre uns auf Amazon Music" href="https://www.amazon.de/music/player/artists/B0FR3J269M/küstenspacken" target='BLANK'>
            <img src={amazon} height={logoHeight} />
          </a>
          <a class="social-link" alt="Höre uns auf Apple Music" href="https://music.apple.com/de/artist/k%C3%BCstenspacken/1839757833" target='BLANK'>
            <img src={apple} height={logoHeight} />
          </a>
          <a class="social-link" alt="Höre uns auf YouTube Music" href="https://music.youtube.com/channel/UC5UQbL_CwnO7BK9Mj4WoEEg?si=vdJQVrAeDh4vy7Hm" target='BLANK'>
            <img src={youtubeMusic} height={logoHeight} />
          </a>
        </div>
    </div>
  )
}

export default Sounds